import { PAGINATION_LIMIT } from '@constants/generic';

import {
  DropOffStatusFilter,
  FormDropOff,
  FormSubmissionsPagination
} from '../types';

interface FilterMockDropOffsParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: DropOffStatusFilter;
}

export const filterMockDropOffs = (
  dropOffs: FormDropOff[],
  params: FilterMockDropOffsParams
): { data: FormDropOff[]; pagination: FormSubmissionsPagination } => {
  const page = params.page ?? 0;
  const limit = params.limit ?? PAGINATION_LIMIT;
  const search = params.search?.trim()?.toLowerCase() || '';
  const { status } = params;

  let filtered = dropOffs;

  if (status && status !== 'all') {
    filtered = filtered.filter((row) => row.status === status);
  }

  if (search) {
    filtered = filtered.filter((row) =>
      (row.name?.toLowerCase() || '').includes(search)
    );
  }

  const totalRows = filtered.length;
  const start = page * limit;
  const data = filtered.slice(start, start + limit);

  return {
    data,
    pagination: {
      page,
      limit,
      totalRows,
      lastPage: start + limit >= totalRows
    }
  };
};

export default filterMockDropOffs;
